<mat-form-field
  class="relative rich-text-wrapper"
  [ngClass]="inputClass"
  appearance="outline"
  [hideRequiredMarker]="true"
  floatLabel="always"
  [class.mb-1]="ctrl?.invalid"
  [class.mb-0]="!ctrl?.invalid || !ctrl?.touched"
>
  <mat-label [hidden]="!showLabel">
    <span>{{ inputLabel | titlecase }}</span>
    <span *ngIf="isRequired" class="color-error">*</span>:
  </mat-label>

  <app-quill
    #matEditor
    [testId]="[testId, 'editor'] | join"
    [formControl]="ctrl.control"
    [errorStateMatcher]="errorMatcher()"
    [styles]="{ minHeight: minHeight + 'px'}"
  >
    <div quill-editor-toolbar>
      <select class="ql-size" [attr.data-test-id]="[testId, 'size'] | join">
        <option value="0.75em">Small</option>
        <option value="1.125em" selected>Normal</option>
        <option value="1.5em" style="font-size: 1.5em">Large</option>
        <option value="2.5em" style="font-size: 2.5em">Huge</option>
      </select>
      <button class="ql-bold" [attr.data-test-id]="[testId, 'bold'] | join"></button>
      <button class="ql-italic" [attr.data-test-id]="[testId, 'italic'] | join"></button>
      <button class="ql-script" value="sub" [attr.data-test-id]="[testId, 'sub'] | join"></button>
      <button class="ql-script" value="super" [attr.data-test-id]="[testId, 'super'] | join"></button>

      <select class="ql-color" [title]="'Color'" [attr.data-test-id]="[testId, 'color'] | join"></select>

      <select class="ql-background" [title]="'BackgroundColor'" [attr.data-test-id]="[testId, 'bg_color'] | join"></select>
      <span class="ql-formats">
        <div id="counter"></div>
      </span>
      <span class="ql-formats" *ngIf="extras.includes('image') || extras.includes('link')">
        <button class="ql-link" type="button" *ngIf="extras.includes('link')" [attr.data-test-id]="[testId, 'link'] | join">
          <svg viewBox="0 0 18 18">
            <line class="ql-stroke" x1="7" x2="11" y1="7" y2="11"></line>
            <path
              class="ql-even ql-stroke"
              d="M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z"
            ></path>
            <path
              class="ql-even ql-stroke"
              d="M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z"
            ></path>
          </svg>
        </button>
        <button class="ql-image" type="button" *ngIf="extras.includes('image')" [attr.data-test-id]="[testId, 'image'] | join">
          <svg viewBox="0 0 18 18">
            <rect class="ql-stroke" height="10" width="12" x="3" y="4"></rect>
            <circle class="ql-fill" cx="6" cy="7" r="1"></circle>
            <polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline>
          </svg>
        </button>
      </span>
    </div>
  </app-quill>

  <mat-hint *ngIf="customHint" [class]="customHint.hintClass">
    <span *ngIf="customHint.showDefaultIcon" class="icon icon-info icon-fs-md mr-q"></span>
    <ng-container [ngTemplateOutlet]="customHint.templateRef"></ng-container>
  </mat-hint>

  <mat-hint *ngIf="inputHint && !isWarningVisible" class="hint d-flex">
    <span *ngIf="inputHintIcon" class="icon icon-info icon-fs-md mr-q"></span>
    <span class="fs-sm" [innerHTML]="inputHint"></span>
  </mat-hint>

  <mat-hint *ngIf="isWarningVisible" class="color-warning d-flex ai-center">
    <span class="icon icon-error icon-fs-md mr-q"></span>
    <span class="fs-sm">{{ warningMessage }}</span>
  </mat-hint>

  <mat-error>
    <span class="icon icon-error fs-md"></span>
    {{ getErrorMessage() }}
  </mat-error>
</mat-form-field>
